import { render, staticRenderFns } from "./StartMarker.vue?vue&type=template&id=a2e30aa8&scoped=true&lang=html&"
var script = {}
import style0 from "./StartMarker.vue?vue&type=style&index=0&id=a2e30aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e30aa8",
  null
  
)

export default component.exports